import { useState } from 'react';
import { useLocale, useT } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';

const STATUSES = ['LIVE', 'PROTOTYPE', 'RESEARCH', 'FUTURE'] as const;

export default function AiLab() {
  const locale = useLocale();
  const t = useT();
  const [filter, setFilter] = useState<string | null>(null);
  const state = useApiData(() => contentApi.aiLabProjects(locale, filter ?? undefined), [locale, filter]);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <div className="section-head reveal is-visible">
          <span className="eyebrow">{t('nav.ai_lab')}</span>
          <h1>CYRKIL AI Lab</h1>
          <p className="body-lg">Applied AI, Computer Vision, NLP, Generative AI, Multimodal AI, Robotics AI, Digital Twins. Every project is tagged so research is never presented as a shipped product.</p>
        </div>
        <div className="flex gap-3" style={{ flexWrap: 'wrap', marginBottom: 24 }}>
          <button className={`chip-filter ${!filter ? 'is-active' : ''}`} onClick={() => setFilter(null)}>
            All
          </button>
          {STATUSES.map((s) => (
            <button key={s} className={`chip-filter ${filter === s ? 'is-active' : ''}`} onClick={() => setFilter(s)}>
              {s}
            </button>
          ))}
        </div>
        <AsyncSection
          state={state}
          render={(projects) => (
            <div className="card-grid">
              {projects.map((p) => (
                <div className="card reveal is-visible" key={p.id}>
                  <span className={`badge badge-${p.status.toLowerCase()}`}>{p.status}</span>
                  <h3 style={{ marginTop: 12 }}>{p.title}</h3>
                  <p className="body-sm">{p.description}</p>
                </div>
              ))}
            </div>
          )}
        />
      </div>
    </section>
  );
}
